/** @jsx isolateComponent */
import { css } from '@emotion/core';

import {
  Colors,
  Heading,
  HeadingLevel,
  Typography,
} from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import Folder from '../Folder';

import { DataType, ZapType } from '../useData';

type FolderGroupProps = {
  folders: DataType[0]['folders'];
  forceFoldersOpen: boolean;
  onSelect: (item: ZapType) => void;
  title: string;
};

const folderGroupTitleCss = css`
  ${Typography.smallPrint1Bold}
  color: ${Colors.neutral700};
  font-size: 12px;
  line-height: 40px;
`;

const foldersCss = css`
  display: grid;
  grid-row-gap: 5px;
`;

/** Renders a single group of folders within `<Browser>`. */
const FolderGroup = ({
  folders,
  forceFoldersOpen,
  onSelect,
  title,
}: FolderGroupProps) => {
  return (
    <li>
      <Heading css={folderGroupTitleCss}>{title}</Heading>
      <HeadingLevel>
        <ul css={foldersCss}>
          {folders.map(folder => (
            <Folder
              forceOpen={forceFoldersOpen}
              key={folder.id}
              onSelect={onSelect}
              {...folder}
            />
          ))}
        </ul>
      </HeadingLevel>
    </li>
  );
};

export default FolderGroup;
